export class CustomReconnectPolicy {
    nextRetryDelayInMilliseconds(_retryContext: any) {
        return 5000 // Retry every 5 seconds indefinitely
    }
}